import { createHttpAction } from '@securitize/ui-components';
import { GET_QUALIFICATION_NEXT } from '../views/Pages/InvestorQualification/actionTypes';

import {
  sessionNext, loginNext, logoutNext,
} from './actionTypes';

export const getQualification = () => createHttpAction(GET_QUALIFICATION_NEXT).action;
export const getUserSession = (onFinish = () => undefined) => createHttpAction(
  sessionNext,
  {},
  { onFinish, onSuccess() { getQualification(); } },
).action;
export const loginUser = (data, onFinish = () => undefined) => createHttpAction(
  loginNext,
  { body: { ...data } },
  { onFinish, onSuccess() { getQualification(); } },
).action;
export const logoutUser = (options) => createHttpAction(logoutNext, {}, options).action;
